import React from 'react';

import { Button, Divider, Header, Text } from '@rbilabs/universal-components';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import crashlytics from 'utils/crashlytics';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

import { ConfigSettings } from '../components/config-settings';
import { EnvItem } from '../components/env-item';
import { ExperimentFlags } from '../components/experiment-flags';
import { HiddenSection } from '../components/hidden-section';
import { LDFlags } from '../components/ld-flags';
import { LocalStorageItems } from '../components/local-storage-items';

import { StoreDiagnostics } from './store-diagnostics';

export const InternalDiagnostics = () => {
  const enableInternalDiagnosticTools = useFlag(LaunchDarklyFlag.ENABLE_INTERNAL_DIAGNOSTIC_TOOLS);

  if (!enableInternalDiagnosticTools) {
    return null;
  }

  return (
    <>
      <Header pt={4} variant="headerFour">
        User Auth Info
      </Header>
      <EnvItem envKey="Auth Token" value={syncStorage.getString(SyncStorageKey.USER_ID)} />
      <Divider />
      <Divider />
      <ExperimentFlags />
      <Divider />
      <ConfigSettings />
      <Divider />
      <LDFlags />
      <Divider />
      <LocalStorageItems />
      <Divider />
      <HiddenSection
        title="Force Crash App"
        content={
          <>
            <Text marginBottom={'$5'}>
              Force Crash the App. Useful for testing crash handling, logging or other situations.
            </Text>
            <Button onPress={() => crashlytics().crash()}>Force Crash App</Button>
          </>
        }
      />
      <Divider />
      <StoreDiagnostics />
    </>
  );
};
